"use strict";
/**
 * A logger to help us to use Salla.logger.log like console.log
 *
 * @namespace Salla.logger
 *
 * @credits @Ammar Hasan
 * @see https://stackoverflow.com/a/21856736
 *
 */
export default (function (c) {
  "use strict";
  let history=[];
  let prefixes=[];
  
  let proxy = {
    log: function (a, type) {
      if (!c) {
        return; /* return or call your custom function here */
      }

      //@ts-ignore
      if (!salla.config.isDebug()) {
        return;
      }

      history.push([type,a]);

      // let's force trace for all logs when the debug is trace level
      //@ts-ignore
      if (salla.config.get('debug') === 'trace') {
        type = 'trace';
      }
      let colorableTypes = {
        event: '#CFF680',
        backend: '#7b68ee'
      };

      let l = c.log,
        f = type === undefined ? l : (this.__dict__[type] || l);

      let style = ['%cTwilight', 'color: #5cd5c4;font-weight:bold; border:1px solid #5cd5c4; padding: 2px 6px; border-radius: 5px;'];
      prefixes.forEach(prefix => {
        style[0] += prefix[0];
        style.push(prefix[1]);
      })

      let color = colorableTypes[type];
      if (color) {
        style[0] += '%c' + type[0].toUpperCase() + type.substring(1);
        style.push(`margin-left: 5px;color: ${color};font-weight:bold; border:1px solid ${color}; padding: 2px 6px; border-radius: 5px;`)
      }

      f.call(c, ...style.concat(...a))
    },
    __dict__: {
      "trace": c.trace,
      "debug": c.debug,
      "info": c.info,
      "warn": c.warn,
      "error": c.error
    }
  };

  return {
    event: function () {
      proxy.log(arguments, "event");
    },
    trace: function () {
      proxy.log(arguments, "trace");
    },
    debug: function () {
      proxy.log(arguments, "debug");
    },
    info: function () {
      proxy.log(arguments, "info");
    },
    warn: function () {
      proxy.log(arguments, "warn");
    },
    error: function () {
      proxy.log(arguments, "error");
    },
    log: function () {
      proxy.log(arguments, undefined);
    },
    //use this to pass messages from backEnd, no need to add documentations, because it will no passed in production
    backend: function () {
      proxy.log(arguments, "backend");
    },
    //this for internal usage to pass multi logs using one function, no need to add it to documentation @see \Salla\Core\Traits\WithStageLogger::debug
    logs: function (logs) {
      //@ts-ignore
      [logs].flat().forEach(logData => logData && proxy.log([logData].flat(), 'backend'));
    },
    history: function () {
      history.map(payload => c.log(payload[0], ...payload[1]));
      return history;
    },
    addPrefix: function (prefix) {
      Array.isArray(prefix) ? prefixes.unshift(prefix) : this.warn('addPrefix receives array only!');
      return this;
    }
  };
}(console))
